import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';
import Button from '../../../components/ui/Button';

const ReportParameterPanel = ({ 
  parameters, 
  onParameterChange, 
  onGenerateReport, 
  onResetParameters,
  isGenerating 
}) => {
  const reportTypes = [
    { value: 'monthly-summary', label: 'Resumo Mensal' },
    { value: 'client-profitability', label: 'Lucratividade por Cliente' },
    { value: 'expense-breakdown', label: 'Detalhamento de Despesas' },
    { value: 'year-comparison', label: 'Comparação Anual' },
    { value: 'cash-flow', label: 'Fluxo de Caixa' },
    { value: 'category-analysis', label: 'Análise por Categoria' }
  ];

  const periodOptions = [
    { value: 'current-month', label: 'Mês Atual' },
    { value: 'last-month', label: 'Mês Anterior' },
    { value: 'current-quarter', label: 'Trimestre Atual' },
    { value: 'last-quarter', label: 'Trimestre Anterior' },
    { value: 'current-year', label: 'Ano Atual' },
    { value: 'last-year', label: 'Ano Anterior' },
    { value: 'custom', label: 'Período Personalizado' }
  ];

  const clientOptions = [
    { value: 'all', label: 'Todos os Clientes' },
    { value: 'maria-santos', label: 'Maria Santos' },
    { value: 'joao-silva', label: 'João Silva' },
    { value: 'ana-costa', label: 'Ana Costa' },
    { value: 'pedro-oliveira', label: 'Pedro Oliveira' },
    { value: 'carla-souza', label: 'Carla Souza' }
  ];

  const categoryOptions = [
    { value: 'all', label: 'Todas as Categorias' },
    { value: 'accommodation', label: 'Hospedagem' },
    { value: 'transport', label: 'Transporte' },
    { value: 'marketing', label: 'Marketing' },
    { value: 'taxes', label: 'Impostos' },
    { value: 'salaries', label: 'Salários' },
    { value: 'office', label: 'Escritório' }
  ];

  const comparisonOptions = [
    { value: 'none', label: 'Sem Comparação' },
    { value: 'previous-period', label: 'Período Anterior' },
    { value: 'same-period-last-year', label: 'Mesmo Período Ano Anterior' },
    { value: 'budget', label: 'Orçamento Planejado' }
  ];

  return (
    <div className="h-full flex flex-col bg-card border-r border-border">
      <div className="p-6 border-b border-border">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name="Settings" size={20} className="text-primary" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-foreground">Parâmetros do Relatório</h2>
            <p className="text-sm text-muted-foreground">Configure os filtros e opções</p>
          </div>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto p-6 space-y-6">
        <div>
          <Select
            label="Tipo de Relatório"
            options={reportTypes}
            value={parameters?.reportType}
            onChange={(value) => onParameterChange('reportType', value)}
            required
          />
        </div>

        <div>
          <Select
            label="Período"
            options={periodOptions}
            value={parameters?.period}
            onChange={(value) => onParameterChange('period', value)}
            required
          />
        </div>

        {parameters?.period === 'custom' && (
          <div className="space-y-4 p-4 bg-muted/50 rounded-lg">
            <Input
              label="Data Inicial"
              type="date"
              value={parameters?.startDate}
              onChange={(e) => onParameterChange('startDate', e?.target?.value)}
              required
            />
            <Input
              label="Data Final"
              type="date"
              value={parameters?.endDate}
              onChange={(e) => onParameterChange('endDate', e?.target?.value)}
              required
            />
          </div>
        )}

        <div>
          <Select
            label="Cliente"
            options={clientOptions}
            value={parameters?.client}
            onChange={(value) => onParameterChange('client', value)}
            searchable
          />
        </div>

        <div>
          <Select
            label="Categoria"
            options={categoryOptions}
            value={parameters?.category}
            onChange={(value) => onParameterChange('category', value)}
            multiple
            searchable
          />
        </div>

        <div>
          <Select
            label="Comparação"
            options={comparisonOptions}
            value={parameters?.comparison}
            onChange={(value) => onParameterChange('comparison', value)}
          />
        </div>

        <div className="space-y-3 p-4 bg-muted/50 rounded-lg">
          <p className="text-sm font-medium text-foreground mb-3">Opções de Visualização</p>
          <Checkbox
            label="Incluir Gráficos"
            checked={parameters?.includeCharts}
            onChange={(e) => onParameterChange('includeCharts', e?.target?.checked)}
          />
          <Checkbox
            label="Incluir Tabelas Detalhadas"
            checked={parameters?.includeTables}
            onChange={(e) => onParameterChange('includeTables', e?.target?.checked)}
          />
          <Checkbox
            label="Incluir Resumo Executivo"
            checked={parameters?.includeSummary}
            onChange={(e) => onParameterChange('includeSummary', e?.target?.checked)}
          />
          <Checkbox
            label="Mostrar Tendências"
            checked={parameters?.showTrends}
            onChange={(e) => onParameterChange('showTrends', e?.target?.checked)}
          />
        </div>
      </div>
      <div className="p-6 border-t border-border space-y-3">
        <Button
          variant="default"
          fullWidth
          iconName="FileText"
          iconPosition="left"
          loading={isGenerating}
          onClick={onGenerateReport}
        >
          Gerar Relatório
        </Button>
        <Button
          variant="outline"
          fullWidth
          iconName="RotateCcw"
          iconPosition="left"
          onClick={onResetParameters}
        >
          Resetar Parâmetros
        </Button>
      </div>
    </div>
  );
};

export default ReportParameterPanel;